export default __webpack_public_path__ + "static/media/elevate-pyl-banner-3.aac3dc97.jpg";